import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    rowContainer: {
        ...theme.mixins.flex.displayFlex,
        ...theme.mixins.flex.flexDirectionRow,
        ...theme.mixins.flex.alignItemsCenter,
        '& .MuiTextField-root': {
            marginRight: theme.spacing(3),
        },
    },
    // Larger spacing variant for dynamic field rows needing more separation
    rowContainerLargeSpacing: {
        '& .MuiTextField-root': {
            marginRight: theme.spacing(4),
        },
    },
}));

export default function NgpRow({ children, className, largeSpacing = false }) {
    const classes = useStyles();
    const spacingClass = largeSpacing ? classes.rowContainerLargeSpacing : '';
    const combinedClassName = `${classes.rowContainer} ${spacingClass} ${className || ''}`.trim();

    return <div className={combinedClassName}>{children}</div>;
}

NgpRow.propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
    largeSpacing: PropTypes.bool,
};

NgpRow.defaultProps = {
    className: undefined,
    largeSpacing: false,
};
